// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__h-OoP","modalForm":"UpgradeEpcsModal_modalForm__ftAIG","modalFooter":"UpgradeEpcsModal_modalFooter__mueN6"};